module.exports = __webpack_public_path__ + "static/media/notFound.f5a85f64.svg";